export class FiltroPadrao{
  codigoPolo?:number;
  nomePolo?: string;
  codigoDiretoria:number;
  nomeDiretoria?: string;
  codigoEscola:number;
  nomeEscola?: string;
  codigoTurno?:number;
  codigoTurma?:number;
  codigoGravidade?:number;
  anoAtual?:number;
  codigoTipoEnsino?:number;
  nomeTipoEnsino?:string;
  atividadeDiretoria?:boolean = false;
  psicologosInativos?:boolean = false;
  codigoPOC?:number;
  fpDataInicio?:Date | null;
  fpDataFim?:Date | null;
  cpf?: string;
  codigoMunicipio?: number | null;
  nomeMunicipio?: string;
  codigoTipoIdentificador?: number;
  nomePOC?: string;
}
